const statusPorSituacao = [
    {
        regra: 'SGTEC-UABS-PAG-02',
        situacoes: [
            {
                id: 0,
                status: [-1, 0, 1, 2, 3, 4, 5, 8]
            },
            {
                id: 1,
                status: [-1, 0, 3]
            },
            {
                id: 2,
                status: [-1, 1, 4]
            },
            {
                id: 3,
                status: [-1, 2, 5, 8]
            }
        ]
    },
    {
        regra: 'SGTEC-UFI-PAG-00',
        situacoes: [
            {
                id: 0,
                status: [-1, 0, 1, 2, 3, 4, 5, 8]
            },
            {
                id: 1,
                status: [-1, 0, 1, 3, 4]
            },
            {
                id: 2,
                status: [-1, 8, 2 ]
            },
            {
                id: 3,
                status: [-1, 5]
            }
        ]
    }
]

export default statusPorSituacao
